import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgCustomXLSXFile = ({
  color,
  alt,
  "aria-roledescription":
    roleDescription = "Represents an Excel Open XML Spreadsheet (.xlsx) file",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="32"
    height="41"
    viewBox="0 0 32 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <path
      d="M31.4099 9.26001V37.61C31.4099 38.71 30.5099 39.61 29.4099 39.61H6.62988C5.52988 39.61 4.62988 38.71 4.62988 37.61V2.51001C4.62988 1.41001 5.52988 0.51001 6.62988 0.51001H22.7999L31.4099 9.26001Z"
      fill="white"
    />
    <path
      d="M29.4099 40.1H6.62988C5.24988 40.1 4.12988 38.98 4.12988 37.6V2.5C4.12988 1.12 5.24988 0 6.62988 0H22.7999C22.9299 0 23.0599 0.0500015 23.1599 0.150002L31.7699 8.9C31.8599 8.99 31.9099 9.12 31.9099 9.25V37.6C31.9099 38.98 30.7899 40.1 29.4099 40.1ZM6.62988 1C5.79988 1 5.12988 1.67 5.12988 2.5V37.6C5.12988 38.43 5.79988 39.1 6.62988 39.1H29.4099C30.2399 39.1 30.9099 38.43 30.9099 37.6V9.46L22.5899 1H6.62988Z"
      fill="#C4CBD0"
    />
    <path
      d="M30.8698 9.25998H24.7998C23.6998 9.25998 22.7998 8.35998 22.7998 7.25998V1.16998"
      fill="white"
    />
    <path
      d="M30.8698 9.75998H24.7998C23.4198 9.75998 22.2998 8.63998 22.2998 7.25998V1.16998C22.2998 0.889983 22.5198 0.669983 22.7998 0.669983C23.0798 0.669983 23.2998 0.889983 23.2998 1.16998V7.25998C23.2998 8.08998 23.9698 8.75998 24.7998 8.75998H30.8698C31.1498 8.75998 31.3698 8.97998 31.3698 9.25998C31.3698 9.53998 31.1498 9.75998 30.8698 9.75998Z"
      fill="#C4CBD0"
    />
    <path
      d="M26.03 31.66H1.2C0.540005 31.66 0 31.12 0 30.46V16.52C0 15.86 0.540005 15.32 1.2 15.32H26.03C26.69 15.32 27.23 15.86 27.23 16.52V30.46C27.23 31.12 26.7 31.66 26.03 31.66Z"
      fill="#2BC77C"
    />
    <path
      d="M4.86364 20.1818L5.92614 22.0198H5.97159L7.04545 20.1818H8.61932L6.86364 23.0908L8.67614 25.9999H7.0625L5.97159 24.142H5.92614L4.83523 25.9999H3.23295L5.03693 23.0908L3.27841 20.1818H4.86364ZM9.34659 25.9999V20.1818H10.7528V24.8579H13.1733V25.9999H9.34659ZM17.0462 21.9261C17.0272 21.7177 16.9429 21.5558 16.7933 21.4403C16.6456 21.3229 16.4344 21.2641 16.1598 21.2641C15.978 21.2641 15.8265 21.2878 15.7053 21.3352C15.584 21.3825 15.4931 21.4479 15.4325 21.5312C15.3719 21.6126 15.3407 21.7064 15.3388 21.8124C15.335 21.8996 15.352 21.9763 15.3899 22.0426C15.4297 22.1088 15.4865 22.1676 15.5604 22.2187C15.6361 22.2679 15.727 22.3115 15.8331 22.3494C15.9392 22.3872 16.0585 22.4204 16.1911 22.4488L16.6911 22.5624C16.9789 22.6249 17.2327 22.7083 17.4524 22.8124C17.674 22.9166 17.8596 23.0407 18.0092 23.1846C18.1607 23.3285 18.2753 23.4943 18.353 23.6818C18.4306 23.8693 18.4704 24.0795 18.4723 24.3124C18.4704 24.6799 18.3776 24.9952 18.1939 25.2585C18.0102 25.5217 17.746 25.7234 17.4013 25.8636C17.0585 26.0037 16.6446 26.0738 16.1598 26.0738C15.6731 26.0738 15.2488 26.0009 14.8871 25.8551C14.5253 25.7092 14.2441 25.4876 14.0433 25.1903C13.8426 24.8929 13.7393 24.517 13.7337 24.0624H15.0803C15.0916 24.2499 15.1418 24.4062 15.2308 24.5312C15.3198 24.6562 15.442 24.7509 15.5973 24.8153C15.7545 24.8797 15.9363 24.9119 16.1428 24.9119C16.3321 24.9119 16.4931 24.8863 16.6257 24.8352C16.7602 24.784 16.8634 24.713 16.9354 24.6221C17.0073 24.5312 17.0443 24.427 17.0462 24.3096C17.0443 24.1997 17.0102 24.106 16.9439 24.0283C16.8776 23.9488 16.7753 23.8806 16.6371 23.8238C16.5007 23.7651 16.3265 23.7111 16.1143 23.6619L15.5064 23.5198C15.0026 23.4043 14.6058 23.2177 14.3161 22.9602C14.0263 22.7007 13.8823 22.3503 13.8842 21.909C13.8823 21.5492 13.9789 21.2338 14.174 20.963C14.3691 20.6922 14.639 20.481 14.9837 20.3295C15.3284 20.178 15.7214 20.1022 16.1626 20.1022C16.6134 20.1022 17.0045 20.1789 17.3359 20.3323C17.6693 20.4838 17.9278 20.6969 18.1115 20.9715C18.2952 21.2462 18.389 21.5643 18.3928 21.9261H17.0462ZM20.6058 20.1818L21.6683 22.0198H21.7138L22.7876 20.1818H24.3615L22.6058 23.0908L24.4183 25.9999H22.8047L21.7138 24.142H21.6683L20.5774 25.9999H18.9751L20.7791 23.0908L19.0206 20.1818H20.6058Z"
      fill="white"
    />
  </svg>
);

const CustomXLSXFile = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgCustomXLSXFile />
  </BaseIcon>
);

export default CustomXLSXFile;
